export class UserSubscriptionDetailModel {
    public id: string;
    public userId: string;
    public subscriptionPlanId: number;
    public subscriptionStartDate: string;
    public subscriptionEndDate: string;
    public createdOn: string;
}
